<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="patrimonies"
    :maskFields="maskFields"
    sortByField="id"
    :indexNested="true"
  >
    <!-- :key="JSON.stringify(patrimonies)" -->

    <template slot="new">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="!readOnly">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="!readOnly">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "id" },
        { text: "Placa", align: "left", sortable: true, value: "plate" },
        { text: "UF", align: "left", sortable: true, value: "plateState.shortName" },
        { text: "Categoria", align: "left", sortable: true, value: "patrimonyCategory.name" },
        { text: "Número ANTT", align: "left", sortable: true, value: "rntc" },
        { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        // {
        //   field: 'price', 
        //   mask: 'currency'
        // }, 
      ],
    };
  },
  props: {
    patrimonies: {
      type: Array,
      default: []
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "Veículo"
    },
    modelNamePlural: {
      type: String,
      default: "Veículos"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  created() {
  },
  methods: {
    entryUpdated: function(){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(newlyEntry){
      this.patrimonies.push(newlyEntry);
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
  }
};

</script>

<style scoped></style>
